import type { ServiceCardItem } from "@components/ServiceCardItem.js";
import brackets from "@core/assets/icons/brackets.svg?raw";
import type { Tenant } from "@core/schema/Tenant.js";
import { getTechnologiesPath } from "@core/schema/paths/getTechnologiesPath.js";

export function getProblemsSolvedProduction(tenant: Tenant): ServiceCardItem[] {
	return [
		{
			title: "Zdlouhavé manuální procesy",
			desc: `Vyvineme vám interní aplikaci nebo jiný software na míru, který automatizuje opakované úkony a ušetří vám čas i nervy.`,
			iconName: brackets,
			show: true,
		},
		{
			title: "Zastaralý a nefunkční web",
			desc: `Je pro vás současný firemní web či e-shop spíš starostí než přínosem? Vyvineme nový a moderní, který bude odpovídat současným [${getTechnologiesPath(tenant)}][[technologiím]] i potřebám vašich zákazníků.`,
			iconName: brackets,
			show: true,
		},
		{
			title: "Nepřehledná data v různých systémech",
			desc: "Propojíme vaše stávající systémy tak, aby si mezi sebou data předávaly automaticky a abyste v informacích měli přehled.",
			iconName: brackets,
			show: true,
		},
		{
			title: "Zmatky v docházce zaměstnanců",
			desc: "Dodáme vám řešení na míru pro evidenci docházky, a to i v nestandardních podmínkách. Poradíme si také s evidencí pracovníků přes RFID (technologie bezkontaktní identifikace).",
			iconName: brackets,
			show: true,
		},
		{
			title: "Vysoké náklady na ostrahu",
			desc: "Rádi byste ušetřili personální náklady? Nasadíme u vás ve výrobě chytré kamery nebo automatické brány, které fungují i v rámci ostrahy.",
			iconName: brackets,
			show: true,
		},
		{
			title: "Chaos při doručení zboží",
			desc: `Vyvineme systém, který vás nebo vaše zaměstnance automaticky upozorní na doručené zásilky.`,
			iconName: brackets,
			show: true,
		},
	];
}
